import * as React from 'react';
import classnames from 'classnames';
import { Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { LoyaltyPoint } from '@grandvisionhq/fun-loyalty-points';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/carts-v2';
import '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../../../StepShipping/selectors.js';
import '@grandvisionhq/icons';
import { LocationInfo } from '../../../modules/LocationInfo/layout/LocationInfo.js';
import '../../../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../../../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/api-client';
import '@grandvisionhq/auth';
import '../../../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/set-store.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../../../utils/get-customer-details-payload.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../../../state.js';
import '@grandvisionhq/locations';
import '@grandvisionhq/lib-utils-html';
import '../../../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '@grandvisionhq/bloomreach';
import { useOrderDetails } from './hooks/use-order-details.js';

const OrderDetailsSummary = ({ orderData , shippingMethodsAsides , labels ,  })=>{
    var ref;
    const { shippingMethodInfo , isPickupDelivery , pickupLocation , orderDetailsSummaries , features , showInvoiceDetails ,  } = useOrderDetails(orderData, shippingMethodsAsides, labels);
    const { company: CompanySummary , addresses: AddressesSummary , contactDetails: ContactDetailsSummary , invoice: InvoiceSummary ,  } = orderDetailsSummaries;
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "card--colapse-borders"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-card__reset-bottom-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, labels.shipmentDetailsTitle), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, shippingMethodInfo.label, " ", shippingMethodInfo.aside))), isPickupDelivery && pickupLocation && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: pickupLocation
    }), AddressesSummary, showInvoiceDetails && /*#__PURE__*/ React.createElement(React.Fragment, null, InvoiceSummary), ((ref = orderData.billingAddress) === null || ref === void 0 ? void 0 : ref.company) && /*#__PURE__*/ React.createElement(React.Fragment, null, CompanySummary), ContactDetailsSummary, (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && (orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore) && /*#__PURE__*/ React.createElement(Card, {
        "data-t": "service-store-summary",
        className: classnames({
            'checkout-card__reset-top-border-radius': !orderData.loyaltyDetails,
            'checkout-card__reset-border-radius': orderData.loyaltyDetails
        })
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, labels.serviceStoreTitle), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.name), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.streetName, " ", orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.streetNumber))), orderData.loyaltyDetails ? /*#__PURE__*/ React.createElement(Card, {
        "data-t": "loyalty-points-summary",
        className: "checkout-card__reset-top-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, getLabel('checkout.overview.loyaltyPoints.heading')), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, getLabel('checkout.completed.loyaltyPoints.collected'), ":"), /*#__PURE__*/ React.createElement(LoyaltyPoint, {
        loyaltySymbol: getLabel('cart.loyalty.loyaltySymbol'),
        points: orderData.loyaltyDetails.points
    }), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, orderData.loyaltyDetails.cardNumberType === 'LUHN' ? `${getLabel('cart.loyalty.saved.number')}: ${orderData.loyaltyDetails.cardNumber}` : getLabel('cart.loyalty.autoAdded')))) : undefined);
};

export { OrderDetailsSummary };
//# sourceMappingURL=OrderDetailsSummary.js.map
